import { render, staticRenderFns } from "./Setting-type-user.vue?vue&type=template&id=b9164136"
import script from "./Setting-type-user.vue?vue&type=script&lang=js"
export * from "./Setting-type-user.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports